import { BaseBus } from "./BaseBus";

export class AssignablePersonBus extends BaseBus 
{
    constructor(data: AssignablePersonBus) {
        super(data);
    }
    personId: any;
    firstName: string;
    lastName: string;
    fullName: string;
    contactEmail: string;
    mainNumber: string;
    cellNumber: string;
    hasMobile: boolean;
    jobTitle: string;
    requireClockInOut: boolean;
    isActive: boolean;
    canSelect: boolean = true;
}
